import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';

import { SVG_ICON_IMPORTS } from '@valk-nx/helpers/lib/svg-unique-ids/svg-unique-ids.directive';

export type IconType = 'default' | 'success' | 'warning' | 'error';

@Component({
	selector: `vp-status-header`,
	templateUrl: './status-header.html',
	imports: [SVG_ICON_IMPORTS, NgClass],
})
export class StatusHeaderComponent {
	icon = input<string>('');
	iconAnimationClass = input<string>('');
	iconType = input<IconType>('default');
	ariaLabel = input<string>('');
	className = input<string>('');
}
